<template>
  <div class="page" id="page-aboutus">

    <div class="section-header">
      <div class="container">
        <h1>대리점 등록증</h1>
      </div>
    </div>

    <div class="section-body" id="history">
      <div class="container">

        <div class="subsection-header">
          <div class="container">
            <element-tab>
              <element-tab-item @click="introductionTab = '손해보험'" :on="introductionTab == '손해보험'">
                <span style="font-size: 1.5rem;">손해보험</span>

              </element-tab-item>
              <element-tab-item @click="introductionTab = '생명보험'" :on="introductionTab == '생명보험'"><span style="font-size: 1.5rem;">생명보험</span></element-tab-item>
            </element-tab>
          </div>
        </div>

        <div class="subsection-body">
          <div class="container">


            <div class="subsection" v-if="introductionTab == '손해보험'">
              <div class="subsection-list">
                <img src="https://insunetfc-www.s3.ap-northeast-2.amazonaws.com/static/%E1%84%89%E1%85%A9%E1%86%AB%E1%84%92%E1%85%A2%E1%84%87%E1%85%A9%E1%84%92%E1%85%A5%E1%86%B7%E1%84%83%E1%85%A2%E1%84%85%E1%85%B5%E1%84%8C%E1%85%A5%E1%86%B7%E1%84%83%E1%85%B3%E1%86%BC%E1%84%85%E1%85%A9%E1%86%A8%E1%84%8C%E1%85%B3%E1%86%BC.jpg" />
              </div>
            </div>

            <div class="subsection" v-if="introductionTab == '생명보험'">
              <div class="subsection-list">
                <img src="https://insunetfc-www.s3.ap-northeast-2.amazonaws.com/static/%E1%84%89%E1%85%A2%E1%86%BC%E1%84%86%E1%85%A7%E1%86%BC%E1%84%87%E1%85%A9%E1%84%92%E1%85%A5%E1%86%B7%E1%84%83%E1%85%A2%E1%84%85%E1%85%B5%E1%84%8C%E1%85%A5%E1%86%B7%E1%84%83%E1%85%B3%E1%86%BC%E1%84%85%E1%85%A9%E1%86%A8%E1%84%8C%E1%85%B3%E1%86%BC.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  data(){
    return {
      introductionTab: "손해보험",
    }
  }
}
</script>
